<template>
  <div>
    <PageHeader :title="update ? 'ویرایش اطلاعات منتور' : 'اضافه کردن منتور'" :items="pageHeaderItems" />
    <Loader v-if="loading" />
    <b-row v-else>
      <b-col cols="12" md="4">
        <div class="inner__style">
          <div v-if="model.image.length === 0" class="upload-photo-icon d-flex mx-auto justify-content-center align-items-center" @click="$bvModal.show('cropperModal')">
            <div>
              <i class="fas fa-cloud-upload-alt icon-size"></i>
              <div class="upload-text-size">برای آپلود عکس خود کلیک کنید</div>
            </div>
          </div>
          <div v-else class="grand-parent">
            <div class="upload-photo-parent">
              <div class="uploaded-photo">
                <div class="remove-icon" @click="model.image = ''">
                  <i class="fa fa-times"></i>
                </div>
                <img class="previewImage" :src="model.image" />
              </div>
            </div>
          </div>
          <div class="my-3">
            <TextAreaInput rows="2" :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
          </div>
        </div>
        <div class="card p-3 mt-3 my-auto d-flex flex-row justify-content-between">
          <b-form-checkbox v-model="model.isEnable" class="pt-2">
            <div class="mx-1">نمایش منتور</div>
          </b-form-checkbox>
          <b-button @click="$bvModal.show('deleteModal')" variant="outline-secondary">
            <i class="far fa-times-circle"></i>
            <span class="ms-2">حذف منتور</span>
          </b-button>
        </div>
      </b-col>
      <b-col cols="12" md="8">
        <div class="card p-3" style="overflow-y: visible">
          <div class="d-flex align-items-center section-main">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات فردی</span>
            </div>
            <div class="line"></div>
          </div>
          <b-form class="sections">
            <div class="mb-3">
              <BaseText
                :maxlength="2000"
                :value="model.firstName"
                @input="model.firstName = $event"
                :required="true"
                :showError="submit && !model.firstName"
                errortext="وارد کردن نام اجباری است"
                title="نام"
                placeholder="نام"
              />
            </div>
            <div class="mb-3">
              <BaseText
                :maxlength="2000"
                :value="model.lastName"
                @input="model.lastName = $event"
                :required="true"
                :showError="submit && !model.lastName"
                errortext="وارد کردن نام خانوادگی اجباری است"
                title="نام خانوادگی"
                placeholder="نام خانوادگی"
              />
            </div>
            <div class="mb-3">
              <Tags title="حوزه آموزش" :value="model.fields" classes="tags" @input="model.fields = $event" placeholder="حوزه آموزش" />
            </div>
            <div class="mb-3">
              <PeopleInput :userId="model.userId" @update="(e) => (model.userId = e)" />
            </div>
          </b-form>
        </div>
        <div class="card p-3">
          <div class="d-flex align-items-center section-main">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">اطلاعات فردی</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="sections">
            <EditorInput :value="model.description" @input="model.description = $event" title="توضیحات کلی" :hasImage="false" textAreaClass="align-items-center" />
          </div>
        </div>
        <div class="card p-3">
          <div class="d-flex align-items-center section-main">
            <div class="d-flex align-items-center">
              <span class="sectionTitle">درباره منتور</span>
            </div>
            <div class="line"></div>
          </div>
          <div class="sections">
            <EditorInput :value="model.extraDescription" @input="model.extraDescription = $event" title="درباره منتور" textAreaClass="align-items-center" />
          </div>
        </div>
        <div class="card">
          <Section title="تنظیمات سئو">
            <div class="my-3">
              <Tags title="کلیدواژه" :value="model.seoKeyword" classes="tags" @input="model.seoKeyword = $event" placeholder="کلیدواژه" />
            </div>
            <div class="my-3">
              <TextAreaInput :value="model.seoDescription" @input="model.seoDescription = $event" title="توضیحات" textAreaClass="align-items-center" />
            </div>
            <div class="my-3">
              <BaseText :maxlength="2000" :value="model.seoUrlDescription" @input="model.seoUrlDescription = $event" title="متن URL" placeholder="متن URL" />
            </div>
          </Section>
        </div>
      </b-col>
    </b-row>
    <div class="card p-3 d-flex flex-row justify-content-end">
      <b-button @click="$router.push('/list/mentors')">انصراف</b-button>
      <b-button variant="primary ms-2 px-5" @click="addMentor">ثبت</b-button>
    </div>
    <b-modal id="deleteModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="@/assets/images/checked1.svg" />
        </div>
        <div class="error-title text-center">آیا از حذف منتور اطمینان دارید؟</div>
        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" variant="secondary" block @click="$bvModal.hide('deleteModal')">خیر</b-button>
            <b-button class="ms-2 col-6" variant="primary" block @click="deleteMentor">بله</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <Toast :title="message" :error="error" :showToast="message !== ''" />
    <b-modal id="cropperModal" no-close-on-esc hide-footer centered size="md" header-close-variant="dark" cancel-title>
      <template #modal-title>کراپ عکس</template>
      <div class="p-3">
        <ImageCropper :cropperLoading="cropperLoading" @imageSourceChanged="uploadImage($event)">
          <template>
            <div class="my-3">
              <BaseText :maxlength="100" :value="model.imageAlternateText" @input="model.imageAlternateText = $event" title="متن جایگزین" placeholder="متن جایگزین" />
            </div>
          </template>
        </ImageCropper>
      </div>
    </b-modal>
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import Tags from '../../common/form/formModules/Tags.vue'
import EditorInput from '../../common/form/formModules/editorInput.vue'
import fileMannager from '../../../services/file'
import dadbanMentorsProvider from '../../../services/dadban/mentor'
import Toast from '../../common/Toast.vue'
import Loader from '../../widgets/loader.vue'
import ImageCropper from '../../user/ImageCropper.vue'
import PeopleInput from '../PeopleInput.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Section from '../../common/form/Section.vue'
export default {
  name: 'AddMentor',
  components: { PageHeader, BaseText, Tags, EditorInput, Toast, Loader, ImageCropper, PeopleInput, TextAreaInput, Section },
  props: {
    create: {
      type: Boolean,
      default: false,
    },
    update: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        firstName: '',
        lastName: '',
        fields: [],
        userId: '',
        image: '',
        isEnable: true,
        description: '',
        extraDescription: ''.replace(/<[^>]+>/g, ''),
        seoKeyword: [],
        seoDescription: '',
        seoUrlDescription: '',
        imageAlternateText: '',
        imageDescription: '',
      },
      message: '',
      cropperLoading: false,
      submit: false,
      error: false,
      loading: false,
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'مدیریت منتورها', active: true },
      ],
    }
  },
  mounted() {
    if (this.update) {
      this.fetchMentor()
      this.model = this.data
    }
  },
  methods: {
    async addMentor() {
      this.submit = true
      if (!this.model.firstName || !this.model.lastName) {
        window.scrollTo(0, 0)
        return false
      }
      this.loading = true
      try {
        if (this.update) {
          const req = await dadbanMentorsProvider.updateMentor(this.model)
          if (req.status === 200) {
            this.$router.push('/list/mentors' + localStorage.getItem('query'))
          } else {
            this.error = true
            this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
          }
          return false
        }
        const req = await dadbanMentorsProvider.addMentor(this.model)
        if (req.status === 200) {
          this.$router.push('/list/mentors')
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async fetchMentor() {
      this.loading = true
      try {
        const req = await dadbanMentorsProvider.getMentor(+this.$route.params.id)
        this.model = req.data.data.output
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    async uploadImage(e) {
      this.cropperLoading = true
      const req = await fileMannager.addImage({
        base64image: e,
      })
      this.model.image = req.data.data.downloadUrl
      this.cropperLoading = false
      this.$bvModal.hide('cropperModal')
    },
    async deleteMentor() {
      this.loading = true
      try {
        const req = await dadbanMentorsProvider.deleteMentor(+this.$route.params.id)
        this.$bvModal.hide('deleteModal')
        if (req.status === 200) {
          this.$router.push('/list/mentors' + localStorage.getItem('query'))
        } else {
          this.error = true
          this.loading = false
          this.message = 'خطایی رخ داده لطفا دوباره تلاش کنید.'
        }
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionTitle {
  white-space: nowrap;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #556ee6;
}
.line {
  width: 100%;
  margin-right: 20px;
  height: 2px;
  background: #eaeaea;
  border-radius: 10px;
}
.sections {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 6px;
}

.image {
  border-radius: 100%;
  width: 200px;
  height: 200px;
  margin: auto;
}

.tags {
  ::v-deep .badge-secondary {
    background: #dde3ff !important;
    font-size: 14px !important;
    color: #556be6 !important;
    margin: 2px;
    button {
      color: #556be6;
      background: #dde3ff;
    }
  }
}

.inner__style {
  background-color: white;
  padding: 23px;
}

.uploaded-photo {
  height: 122px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
}
.remove-icon {
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gray;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  i {
    color: white;
    // font-size: 20px;
  }
}
.upload-text-size {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
  color: #495057;
}
.icon-size {
  font-size: 45px;
  text-align: center;
  display: block;
  color: #74788d;
}

.upload-photo-icon {
  height: 250px;
  width: 100%;
  border: 2px dashed #ced4da;
  border-radius: 8px;
  cursor: pointer;
}
.grand-parent {
  padding: 20px;
  border: 2px dashed #ced4da;
  justify-content: right;
  display: flex;
  align-items: right;
  position: relative;
}
.activeImageClass {
  border: 3px solid #556ee6;
  border-radius: 5px;
}
.remove-field-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  i {
    // font-size: 18px;
    color: #ff4861;
    // font-weight: 100;
  }
}
.previewImage {
  border-radius: 4px;
}
.checkbox-margin {
  margin-right: 8px;
}
::v-deep .b-form-tags-button {
  display: none;
}
.section-main {
  margin-bottom: 19.97px;
}
::v-deep .b-form-tags-button {
  display: none;
}
</style>
